import './styles.css'

import { PropsWithChildren } from 'react'

import { Box } from '@chakra-ui/react'

export const Pill = ({ children, colorPalette }: PropsWithChildren<{ colorPalette?: string }>) => (
  <Box>
    <span className={['pill', colorPalette].join(' ')}>{children}</span>
  </Box>
)
